// extracted by mini-css-extract-plugin
export default {"createHeader":"CreateChallenge_createHeader__mdE38","createContainer":"CreateChallenge_createContainer__LmyKr","createItem":"CreateChallenge_createItem__NeBNk"};